import React, { useEffect, useRef, useState, useContext } from "react";
import { DraggableItem } from "./DraggableItem";
import { useResize } from "../../../../utils/useResize";
import { SelectableArea } from "./SelectableArea";
import { rectInRect } from "../../../../utils/inBox";
import { DashboardContext } from "../../DashboardContext";
import "./PositionedItemsContainer.css";

interface IPositionedItemsContainer {
    onChangePosition: (index: number, position: {x: number, y: number}, underDropIndex: number)=>void;
    onChangingPosition?: (index: number, position: {x: number, y: number}, underDropIndex: number)=>void;
    onMultiselect: (itemIndexes: number[])=>void;
    muliselectIndexes: number[];
    positions: {x: number, y: number}[], 
    items: React.ReactElement[],
    boundingsRef: React.RefObject<DOMRect[]>
}

export const PositionedItemsContainer = ({boundingsRef, positions, muliselectIndexes, items, onChangePosition, onChangingPosition, onMultiselect}: IPositionedItemsContainer)=>{
    const containerRef = useRef<HTMLDivElement>(null);
    const [shownPositions, setShownPositions] = useState<{x: number, y: number}[]>();
    const windowSize = useResize();
    const { isLeftCollapsed } = useContext(DashboardContext);

    useEffect(()=>{
        if (!containerRef.current){
            return;
        }
        const fallbackRowWidth = 100;
        const fallbackItemHeight = 90;
        const bounds = containerRef.current.getBoundingClientRect();
        let fallbackCounter = 0;
        let unposFallbackCounter = 0;
        let unposFallbackColCounter = 0;
        const newPositions = positions.map(position=>{
            if (!position){
                const newPosition = {
                    x: unposFallbackColCounter * fallbackRowWidth,
                    y: unposFallbackCounter * fallbackItemHeight
                }
                unposFallbackCounter++;
                if (unposFallbackCounter * fallbackItemHeight > bounds.height - fallbackItemHeight){
                    unposFallbackCounter = 0;
                    unposFallbackColCounter++;
                }
                return newPosition;
            }
            if (position.x > bounds.width - fallbackRowWidth || position.y > bounds.height){
                const newPosition = {
                    x: bounds.width - fallbackRowWidth,
                    y: fallbackCounter * fallbackItemHeight
                }
                fallbackCounter++;
                return newPosition
            }
            return position
        });
        setShownPositions(newPositions);
    }, [containerRef.current, windowSize, positions]);

    const boundings = boundingsRef;//useRef<DOMRect[]>([]);

    return <SelectableArea isLeftCollapsed={isLeftCollapsed} onRectChange={(rect, clientPos)=>{
        if (boundings.current.length > positions.length){
            boundings.current = boundings.current.slice(0, positions.length);
        }
        const inside = boundings.current.map((it, i)=>({item: it, index: i})).filter(it=>{
            return rectInRect(rect, new DOMRect(it.item.left - clientPos.x, it.item.top - clientPos.y, it.item.width, it.item.height));
        }).map(it=>it.index);
        onMultiselect(inside);
    }}>
        <div ref={containerRef} className="PositionedItemsContainer">
            {shownPositions && shownPositions.map((position, index)=>{
                return <DraggableItem
                    key={`draggable-item-${index}`}
                    className="PositionedItemsContainer_positionSlot"
                    position={position}
                    onBounding={(rect)=>{
                        if (boundings.current.length > positions.length){
                            boundings.current = boundings.current.slice(0, positions.length);
                        }
                        boundings.current[index] = rect;
                    }}
                    onPositionChange={(newPosition)=>{
                        //console.log(muliselectIndexes);
                            const underDropIndex = boundings.current.findIndex((jt, j)=>j!=index && rectInRect(jt, boundings.current[index]));
                            if (muliselectIndexes && muliselectIndexes.length && muliselectIndexes.includes(index)){
                                muliselectIndexes.forEach(it=>{
                                    const itpos = shownPositions[it];
                                    //console.log('ms ', it, itpos, - position.x + newPosition.x);
                                    setShownPositions(last=>{
                                        const next = [...last];
                                        next[it] = {x: itpos.x - position.x + newPosition.x, y: itpos.y - position.y + newPosition.y};
                                        return next;
                                    })
                                    onChangingPosition?.(it, {x: itpos.x - position.x + newPosition.x, y: itpos.y - position.y + newPosition.y}, underDropIndex);
                                })
                            } else {
                                onChangingPosition?.(index, newPosition, underDropIndex);
                            }
                        }
                    }
                    onPositionChangeEnd={(newPosition)=>{
                        const underDropIndex = boundings.current.findIndex((jt, j)=>j!=index && rectInRect(jt, boundings.current[index]));
                        if (muliselectIndexes && muliselectIndexes.length && muliselectIndexes.includes(index)){
                            muliselectIndexes.forEach(it=>{
                                const itpos = shownPositions[it];
                                onChangePosition?.(it, {x: itpos.x - position.x + newPosition.x, y: itpos.y - position.y + newPosition.y}, underDropIndex);
                            })
                        } else {
                            onChangePosition?.(index, newPosition, underDropIndex);
                        }
                        //onChangePosition(index, newPosition);
                    }}
                >
                    {items[index]}
                </DraggableItem>
            })}
        </div>
    </SelectableArea>
}